export var OrganizationMemberStatus;
(function (OrganizationMemberStatus) {
    OrganizationMemberStatus["APPROVED"] = "approved";
    OrganizationMemberStatus["PENDING"] = "pending";
    OrganizationMemberStatus["REJECTED"] = "rejected";
})(OrganizationMemberStatus || (OrganizationMemberStatus = {}));
//# sourceMappingURL=organization-member-status.enum.js.map